import { useState } from 'react';
import useColumnsPreferenceActions from '../../../../../hooks/useColumnsPreferenceActions';
import { ColumnVisibilityItem, UseColumnsVisibilityParams } from '../columnsVisibility.types';

const useColumnsVisibility = ({
  list,
  columns,
  onClose,
  canRestoreToDefaultColumns: externalCanRestoreToDefaultColumns,
}: UseColumnsVisibilityParams) => {
  const [internalColumns, setInternalColumns] = useState<ColumnVisibilityItem[]>(columns);

  const visibleColumnKeys = internalColumns
    .filter((column) => column.isVisible)
    .map((column) => column.key);

  const {
    canSaveColumns,
    canRestoreToDefaultColumns: computedCanRestoreToDefaultColumns,
    isSavingColumns,
    saveColumns,
  } = useColumnsPreferenceActions({ list, visibleColumnKeys });

  const canRestoreToDefaultColumns =
    computedCanRestoreToDefaultColumns || !!externalCanRestoreToDefaultColumns;

  const toggleColumn = (key: string) => {
    setInternalColumns((current) =>
      current.map((column) =>
        column.key === key ? { ...column, isVisible: !column.isVisible } : column,
      ),
    );
  };

  const restoreToDefault = () => {
    setInternalColumns(
      columns.map((column) => ({
        ...column,
        isVisible: column.showByDefault ?? true,
      })),
    );
  };

  const saveAndApply = () => {
    saveColumns();
    onClose();
  };

  return {
    internalColumns,
    toggleColumn,
    restoreToDefault,
    saveAndApply,
    canSaveColumns,
    canRestoreToDefaultColumns,
    isSavingColumns,
  };
};

export default useColumnsVisibility;
